import {
  DownloadOutlined,
  FileOutlined,
  LinkOutlined,
  PictureOutlined,
  SettingOutlined,
  ShopOutlined,
} from '@ant-design/icons';
import { Button, Col, Flex, Image, Row, Segmented, Space, Tag } from 'antd';
import { format } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useGetProductDetails } from '../../../../utils/api/products/useGetProductDetails';
import { getBrandLogo } from '../../../../utils/fn/products';
import ErrorPage from '../../../authentication/Error';
import LoadingComponent from '../../../loading/LoadingComponent';
import Associations from './tabs/associations';
import Attributes from './tabs/attributes';
import Medias from './tabs/medias';
import Offers from './tabs/offers';
import StructuredDatas from './tabs/structured_datas';

const ProductDetails = () => {
  const params = useParams();
  const navigate = useNavigate();
  const reference = params.reference;
  const tab = params.tab;
  const {
    data: productDetails,
    isLoading,
    isError,
  } = useGetProductDetails(reference);
  const [detailsTab, setDetailsTab] = useState('structured-data');

  // Fonction pour transformer les URLs CDN en fonction de l'environnement
  const transformCdnUrl = (url) => {
    if (!url) return url;
    // En production, on garde les URLs telles quelles
    if (import.meta.env.VITE_NODE_ENV === 'production') {
      return url;
    }

    // En développement/staging, on remplace les URLs sandbox par les URLs de production
    const cdnMappings = [
      {
        sandbox: 'cdn.sandbox.hoortrade.com/casanoov',
        production: 'cdn.casanoov.com',
      },
      {
        sandbox: 'cdn.sandbox.hoortrade.com/sicaan',
        production: 'cdn.sicaan.com',
      },
      {
        sandbox: 'cdn.sandbox.hoortrade.com/cazeboo',
        production: 'cdn.cazeboo.com',
      },
    ];

    let transformedUrl = url;
    cdnMappings.forEach(({ sandbox, production }) => {
      if (transformedUrl.includes(sandbox)) {
        transformedUrl = transformedUrl.replace(sandbox, production);
      }
    });

    return transformedUrl;
  };

  // Synchroniser l'onglet avec l'URL
  useEffect(() => {
    const validTabs = [
      'structured-data',
      'attributes',
      'medias',
      'associations',
      'offers',
    ];

    if (tab && validTabs.includes(tab)) {
      setDetailsTab(tab);
    } else if (!tab) {
      navigate(
        `/dashboard/products/${encodeURIComponent(reference)}/structured-data`,
        {
          replace: true,
        }
      );
    }
  }, [tab, reference, navigate]);

  if (isLoading) {
    return <LoadingComponent />;
  }
  if (isError) {
    return <ErrorPage />;
  }

  const onDetailsTabChange = (key) => {
    setDetailsTab(key);
    navigate(`/dashboard/products/${encodeURIComponent(reference)}/${key}`);
  };

  const detailsTabs = [
    {
      label: 'Données structurées',
      value: 'structured-data',
      icon: <FileOutlined />,
    },
    { label: 'Attributs', value: 'attributes', icon: <SettingOutlined /> },
    { label: 'Médias', value: 'medias', icon: <PictureOutlined /> },
    {
      label: 'Associations (5)',
      value: 'associations',
      icon: <LinkOutlined />,
    },
    { label: 'Offres', value: 'offers', icon: <ShopOutlined /> },
  ];

  return (
    <>
      <Row gutter={[4, 4]}>
        <Col span={3}>
          <Image
            src={transformCdnUrl(productDetails.main_image)}
            width={'95%'}
            height={150}
            style={{ objectFit: 'cover' }}
            fallback="data:image/png;base64,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"
          />
        </Col>
        <Col span={21}>
          <div
            style={{
              height: 150,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
            }}
          >
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                  <Tag color="blue">{productDetails.category?.name}</Tag>
                </div>
                <div>
                  <Button type="primary" disabled icon={<DownloadOutlined />}>
                    Exporter
                  </Button>
                </div>
              </div>
              <h2 style={{ margin: 0 }}>{productDetails.name}</h2>
              <h3 style={{ margin: '4px 0 0 0' }}>
                {productDetails.reference}
              </h3>
            </div>
            <Flex justify="space-between" align="flex-end">
              <Space size={24}>
                <Tag color="green">{productDetails.status}</Tag>
                <Image src={getBrandLogo(productDetails.brand)} width={100} />
              </Space>
              <Space>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'start',
                    flexDirection: 'column',
                  }}
                >
                  <span style={{ fontWeight: 500 }}>Créé le </span>
                  <span>{format(productDetails.created_at, 'dd/MM/yyyy')}</span>
                </div>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'start',
                    flexDirection: 'column',
                  }}
                >
                  <span style={{ fontWeight: 500 }}>Modifié le </span>
                  <span>{format(productDetails.updated_at, 'dd/MM/yyyy')}</span>
                </div>
              </Space>
            </Flex>
          </div>
        </Col>
      </Row>
      <Row gutter={[4, 4]} style={{ marginTop: 16 }}>
        <Col span={24}>
          <Segmented
            options={detailsTabs}
            value={detailsTab}
            onChange={onDetailsTabChange}
            block
          />
        </Col>
        <Col span={24}>
          <div
            style={{
              maxHeight: 'calc(100vh - 400px)', // Ajuste selon la hauteur de l'en-tête et du segmented
              overflowY: 'auto',
              padding: '16px 0',
              scrollBehavior: 'smooth',
            }}
          >
            {detailsTab === 'structured-data' && (
              <>
                <StructuredDatas productDetails={productDetails} />
              </>
            )}
            {detailsTab === 'attributes' && (
              <>
                <Attributes productDetails={productDetails} />
              </>
            )}
            {detailsTab === 'medias' && (
              <>
                <Medias productDetails={productDetails} />
              </>
            )}
            {detailsTab === 'associations' && (
              <>
                <Associations productDetails={productDetails} />
              </>
            )}
            {detailsTab === 'offers' && (
              <>
                <Offers productDetails={productDetails} />
              </>
            )}
          </div>
        </Col>
      </Row>
    </>
  );
};

export default ProductDetails;
